import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Videos from "../components/Videos";
import useHttp from "../hooks/use-http";

const FeedPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("New");
  const [videos, setVideos] = useState([]);

  const { sendRequest, loading, error } = useHttp();

  useEffect(() => {
    const dataFetch = async () => {
      const data = await sendRequest(
        `search?part=snippet&q=${selectedCategory}`
      );

      setVideos(data.items);
    };

    dataFetch();
  }, [selectedCategory, sendRequest]);

  return (
    <Stack sx={{ flexDirection: { sx: "column", md: "row" } }}>
      <Box
        sx={{
          height: { sx: "auto", md: "92vh" },
          borderRight: "1px solid #3d3d3d",
          px: { sx: 0, md: 2 },
          flex: 2,
        }}
      >
        <Sidebar
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        <Typography
          className="copyright"
          variant="body2"
          sx={{ marginTop: 1.5, color: "white" }}
        >
          Copyright 2022 Youtube
        </Typography>
      </Box>

      <Box p={2} sx={{ overflowY: "auto", height: "90vh", flex: 8 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          mb={2}
          sx={{ color: "white" }}
        >
          {selectedCategory} <span style={{ color: "#FC1503" }}>videos</span>
        </Typography>
        <Videos videos={videos} />
      </Box>
    </Stack>
  );
};

export default FeedPage;
